import { generateIndexArray } from '@/presentation/services/utils';
import { ProfileCommentCardSkeleton } from '../ProfileCommentCard';

const SKELETON_COUNT = 5;

function CommentsListSkeleton() {
  return (
    <>
      {generateIndexArray(SKELETON_COUNT).map((index) => (
        <ProfileCommentCardSkeleton key={index} />
      ))}
    </>
  );
}

export default CommentsListSkeleton;
